import { css } from '@emotion/react'

export default css`
    .ant-tree .ant-tree-switcher {
        display: none;
    }
`
